module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"what_changes":"What changes","support":"Support","cosmo_engine":"COsMO Engine","ecosystem":"Ecosystem","board":"Board","connexion":"Connection"},"fr":{"what_changes":"Ce qui change","support":"Accompagnement","cosmo_engine":"COsMO Engine","ecosystem":"Écosystème","board":"Board","connexion":"Connexion"}}')
  delete Component.options._Ctor
}
